import { FC, ReactNode } from 'react'
import { LogoSection, User } from '@/ui/components'

const Header: FC = (): ReactNode => {
    return (
        <header className='antialiased bg-[#262626] z-20 min-h-[6vh] max-h-[6vh] px-4 flex items-center w-full border-[#424242] border-b'>
            <div className='w-full flex flex-wrap justify-between items-center'>
                <LogoSection />
                <User />
            </div>
        </header>
    )
}

export default Header
